// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"topTable_custom_table__2U6bo","nodata":"topTable_nodata__NNPN_"};